import React from 'react'

import Challenges from './pages/Challenges'
import PitStop from './pages/PitStop'
import Leaderboards from './pages/Leaderboards'

import Login from './pages/Login'
import Logout from './pages/Logout'

import NewChallenges from './pages/NewChallenges'
import NewPitStop from './pages/NewPitStop'

import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'

import { isAuthenticated } from "./services/auth";

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isAuthenticated() ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: "/login", state: { from: props.location } }} />
      )
    }
  />
);

function Routes(){
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={ Challenges } />
        <Route exact path="/pitstop" component={ PitStop } />
        <Route exact path="/leaderboards" component={ Leaderboards } />

        <Route exact path="/login" component={ Login } />
        <PrivateRoute exact path="/admin" component={ NewChallenges } />
        <PrivateRoute exact path="/admin/challenges" component={ NewChallenges } />
        <PrivateRoute exact path="/admin/pitstop" component={ NewPitStop } />

        <Route exact path="/logout" component={ Logout } />
      </Switch>
    </BrowserRouter>
  )
}

export default Routes